import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {ResourceCounter, ResourceSearchParams} from '@association/_common/models/apartments.models';

export const LoadList = createAction(
    '[Counters] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Counters] Load List Success',
    props<{ payload: { items: ResourceCounter[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Counters] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetFilter = createAction(
    '[Counters] Set Filter',
    props<{ payload: ResourceSearchParams }>()
);

export const SetLoading = createAction(
    '[Counters] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Counters] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Counters] Update Item Success',
    props<{ payload: ResourceCounter }>()
);

export const DeleteItem = createAction(
    '[Counters] Delete Item',
    props<{ payload: ResourceCounter, params?: { type: 'organization' | 'apartment' } }>()
);

export const DeleteItemSuccess = createAction(
    '[Counters] Delete Item Success',
    props<{ payload: ResourceCounter }>()
);

export const DeleteItemFailure = createAction(
    '[Counters] Delete Item Failure',
    props<{ payload: ResourceCounter }>()
);

export const SetInitialState = createAction(
    '[Counters] Set Initial State'
);
